import React from 'react';

/**
 * VoiceStatusIndicator - Shows voice/call status badge
 */
const VoiceStatusIndicator = ({
  isReady,
  isConnected,
  label = 'Voice Ready',
  className = ''
}) => {
  if (!isReady && !isConnected) return null;

  return (
    <div className={`flex items-center gap-2 px-2 md:px-3 py-1 md:py-1.5 bg-green-500/20 border border-green-500/30 rounded-full ${className}`}>
      <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
      <span className="text-[10px] md:text-xs text-green-400 font-medium">{label}</span>
    </div>
  );
};

export default VoiceStatusIndicator;
